const types = {
    SET_RX_CHANGE_CASE_LIST_LOADING: 'SET_RX_CHANGE_CASE_LIST_LOADING',
    SET_RX_CHANGE_CASE_LIST: 'SET_RX_CHANGE_CASE_LIST',
    SET_RX_CHANGE_CASE_COUNT_LOADING: 'SET_RX_CHANGE_CASE_COUNT_LOADING',
    SET_RX_CHANGE_CASE_COUNT: 'SET_RX_CHANGE_CASE_COUNT',
};

export default types;